import { GetEventResponse, PutEventType } from '@orbit/api-types'
import api from '@lib/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useUpdateEvent = () => {
	const queryClient = useQueryClient()

	return useMutation<GetEventResponse, Error, { tripId: string; eventId: string; eventData: PutEventType }>(
		{
			mutationFn: async ({ tripId, eventId, eventData }) => {
				const response = await api.patch<GetEventResponse>(
					`/trips/${tripId}/events/${eventId}`,
					eventData,
				)
				return response.data
			},
			onSuccess: (_, variables) => {
				// Invalidate and refetch events for this trip
				queryClient.invalidateQueries({ queryKey: ['events', variables.tripId] })
			},
		},
	)
}
